import { render, staticRenderFns } from "./LabelModal.vue?vue&type=template&id=56b13da2"
import script from "./LabelModal.vue?vue&type=script&lang=js"
export * from "./LabelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports